export default __webpack_public_path__ + "static/media/navigation-drawer.c997033e.svg";